import { NextRouter } from "next/router";

export enum HeaderEnum {
  Menu = "menu",
  Back = "back",
  Cart = "cart",
  Skip = "skip",
  Logo = "logo",
  Pagination = "pagination",
  QuickPagination = "QuickPagination",
  OrderType = "OrderType",
  ExtraCenteringDiv = "ExtraCenteringDiv",
  CartSpacer = "CartSpacer",
  Title = "Title",
  Translation = "translation",
}

export enum RouteTypesEnum {
  ALL_USERS = "all-users",
  VISTORS_ONLY = "visitors-only",
  CUSTOMERS_ONLY = "customers-only",
}

export enum EditCartItemEnum {
  CounterIncChange = "CounterIncChange",
  CounterDecChange = "CounterDecChange",
  EditItemDetails = "EditItemDetails",
  DeleteItem = "DeleteItem",
}

// export enum CartActionEnum {
//   Add = "Add",
//   Edit = "Edit",
// }

export enum ChangeCounterFrom {
  ItemView = "ItemView",
  CartView = "CartView",
  AddOns = "AddOns",
}

export enum SideMenuEnum {
  Account = "account",
  Language = "language",
  SignOut = "signout",
  Logout = "logout",
  SignIn = "signin",
  History = "your-history",
  Offers = "your-offers",
  Wallet = "wallet",
  WalletHistory = "wallet-history",
  CallTheRestaurant = "call-restaurant",
  GoToTheBranch = "go-to-branch",
  CallUs = "call-us",
  AllPartnerRestaurants = "all-partner-restaurants",
  PoweredByPrepitLogo = "powered-by-prepit-logo",
  OrderType = "order-type",
  OurPolicies = "our-policies",
  OfflineMode = "switch-to-in-store",
}

export enum TabsEnum {
  Menu = "menu",
  Loyalty = "loyalty",
  PreviousOrders = "previous-orders",
}

export enum PagesEnum {
  Cart = "cart",
  Order = "order",
  Bill = "bill",
  Split = "split",
  Tip = "tip",
  /** The DSQ partner-points webview, full page (prepits/project#4468). */
  PartnerPoints = "partner-points",
  Pay = "pay",
  Quick = "quick",
  Login = "login",
  Location = "location",
  Item = "item/[item]",
  Offer = "offer/[offerId]",
  EditItem = "[item]/edit",
  Restaurant = "[restaurant]",
  Franchise = "[franchise]",
  Category = "[category]",
  NotFound = "404",
  PaymentFailed = "paymentfailed",
  Home = "home",
  Verify = "verify-phone",
  Address = "address",
  PartnerAccount = "partneraccount",
  LoyaltyTermsAndConditions = "loyaltytermsandconditions",
  Account = "account",
  Schedule = "schedule",
  Referral = "referral",
  SelfService = "self-service",
  PaymentStatus = "payment-status",
  DeliveryMap = "delivery-map",
  AllRewards = "all-rewards",
  LoyaltyTiers = "loyalty-tiers",
  DownloadApp = "download-app",
  OfflineMode = "offline-mode",
  AppleWallet = "loyalty-card",
  AppleWalletConfirmation = "loyalty-card-confirmation",
  AppleWalletLogin = "apple-wallet-login",
  AppleWalletVerify = "apple-wallet-verify",
  OurPolicies = "our-policies",
  Rewards = "rewards",
  Wallet = "wallet",
  WalletTopUp = "wallet-top-up",
  WalletTransactions = "wallet-transactions",
  // Where the backend sends a customer back from a Paymob top-up
  // (paymentService.getPaymentRedirectionLink); the names are the backend's.
  WalletTopUpPaid = "pay-paymentInvoice",
  WalletTopUpFailed = "paymentfailed-paymentInvoice",
  Orders = "orders",
}

/**
 * Pages that must not be pulled back to the in-store screen by the
 * `noOnlineUrl` redirect. Login/verify and the whole wallet flow are reached
 * *from* offline mode and drive their own navigation once they finish — the
 * terms page is linked from it too.
 */
export const shouldRedirectToOfflineMode = (router: NextRouter) =>
  !router.pathname.includes(`/${PagesEnum.OfflineMode}`) &&
  !router.pathname.includes(`/${PagesEnum.Login}`) &&
  !router.pathname.includes(`/${PagesEnum.Verify}`) &&
  !router.pathname.includes(`/${PagesEnum.LoyaltyTermsAndConditions}`) &&
  !router.pathname.includes(`/${PagesEnum.AppleWallet}`) &&
  !router.pathname.includes(`/${PagesEnum.AppleWalletConfirmation}`) &&
  !router.pathname.includes(`/${PagesEnum.AppleWalletLogin}`) &&
  !router.pathname.includes(`/${PagesEnum.AppleWalletVerify}`);

export const shouldRedirectToHome = (router: NextRouter) =>
  !router.pathname.includes(`/${PagesEnum.Home}`) &&
  !router.pathname.includes(`/${PagesEnum.Login}`) &&
  !router.pathname.includes(`/${PagesEnum.Verify}`) &&
  !router.pathname.includes(`/${PagesEnum.Location}`) &&
  !router.pathname.includes(`/${PagesEnum.AllRewards}`) &&
  !router.pathname.includes(`/${PagesEnum.LoyaltyTermsAndConditions}`) &&
  !router.pathname.includes(`/${PagesEnum.OurPolicies}`) &&
  !router.pathname.includes(`/${PagesEnum.DownloadApp}`) &&
  !router.pathname.includes(`/${PagesEnum.AppleWallet}`) &&
  !router.pathname.includes(`/${PagesEnum.AppleWalletConfirmation}`) &&
  !router.pathname.includes(`/${PagesEnum.AppleWalletLogin}`) &&
  !router.pathname.includes(`/${PagesEnum.AppleWalletVerify}`) &&
  !router.pathname.includes(`/${PagesEnum.OfflineMode}`) &&
  router.pathname !== `/${PagesEnum.Pay}` &&
  !router.pathname.includes(`/r/`);

export enum SNACK_BAR_ENUM {
  CARD_DELETED = "tip:card-deleted",
  ADD_ITEM_TO_CART = "offers:added-to-cart",
}

export enum OrderTypesEnum {
  TAKE_OUT = "takeout-on-table",
  DINE_IN = "dine-in",
  DELIVERY = "delivery",
  DELIVERYV2 = "deliveryv2",
}

export enum OrderTypesKeysEnum {
  TAKE_OUT = "TAKE_OUT",
  DINE_IN = "DINE_IN",
  DELIVERY = "DELIVERY",
  DELIVERYV2 = "DELIVERYV2",
}

export enum ReceiptSourceTypeEnum {
  GUEST = "Guest",
  CALL_CENTER = "CallCenter",
}

export enum ReceiptSourceEnum {
  WEB = "WEB",
  MOBILE = "MOBILE",
  PARTNER = "PARTNER",
  SELF_SERVICE = "SELF_SERVICE",
  MOB_SELF_SERVICE = "MOB_SELF_SERVICE",
  VISITOR_SELF_SERVICE = "VISITOR_SELF_SERVICE",
  POS = "POS",
}

export enum OFFER_CATEGORY {
  AMOUNT_OFFER = "AMOUNT_OFFER",
  ITEM_OFFER = "ITEM_OFFER",
  BOGO_OFFER = "BOGO_OFFER",
}

export enum PAYMENT_METHOD {
  CASH = "cash",
  ONLINE_CARD = "online_card",
  CARD_ON_DELIVERY = "card_on_delivery",
  NONE = "none",
  POS = "pos",
}

export enum OrderInfoScreenView {
  Cart = "cart",
  Order = "order",
  Pay = "pay",
  OrderSummary = "ordersummary",
}

export enum OnlinePaymentProvider {
  Card = "VISA/MASTER",
  ApplePay = "Apple Pay",
  GooglePay = "Google Pay",
  Mada = "mada",
}

export enum PAYMENT_PROVIDER_ENUM {
  STRIPE = "Stripe",
  PAYMOB = "Paymob",
  PAYMOB_V2 = "Paymob_V2",
  PAYTABS = "Paytabs",
  MYFATOORAH = "Myfatoorah",
  TAP = "Tap",
}

export enum LocalStorageEnum {
  CARTV1 = "cart",
  CARTV2 = "cart/v2",
  CARTV3 = "cart/v3",
  LANG = "lang",
  ORDER = "order",
  ACTIVE_VIEW = "activeView",
  USER_NAME = "USER_NAME",
  PHONE_NUMBER = "PHONE_NUMBER",
  COUNTRY_CODE = "COUNTRY_CODE",
  MENU_DATA = "menu_data",
  ITEMS_DATA = "items_data",
  RECEIPT_NOTE = "receipt_note",
  SWITCH_ADDRESS = "SWITCH_ADDRESS",
  MOBILE_APP_PARTNER = "mobile_app_partner",
  MOBILE_APP_RESTAURANT = "mobile_app_restaurant",
  ITEMS_WITH_CUSTOM_DELIVERY_TIMES = "itemsWithCustomDeliveryTimes",
  HAS_BACK_BUTTON = "HAS_BACK_BUTTON",
  SELF_SERVICE = "selfService",
  DEVICE_NUMBER = "deviceNumber",
  DEVICE_ID = "deviceId",
  PAYMENT_POS_TIMEOUT = "paymentPOSTimeout",
  TOKEN = "TOKEN",
  LOYALTY_POPUP_LAST_SHOWN = "loyalty_popup_last_shown",
  PROMO_POPUP_HISTORY = "promoPopupHistory",
  AUTO_APPLIED_OFFERS = "autoAppliedOffers",
}

export enum CartItemStatus {
  NONE = "NONE",
  CREATED = "CREATED",
  UPDATED = "UPDATED",
  CANCELED = "CANCELED",
}

export enum ReceiptItemStateEnum {
  PENDING = "Pending",
  CONFIRMED = "Confirmed",
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
}

export enum OUT_OF_OPERATION_ENUM {
  BUSY_MODE = "BUSY_MODE",
  IS_OUT_OF_OPERATION_TILL = "IS_OUT_OF_OPERATION_TILL",
  OUTSIDE_OPERATING_HOURS = "OUTSIDE_OPERATING_HOURS",
  INTEGRATED_POS_DOWN = "INTEGRATED_POS_DOWN",
}

export enum CUSTOMER_ANALYTICS_EVENT {
  WELCOME_PAGE_VIEWED = "WELCOME_PAGE_VIEWED",
  ACCEPT_CONSENT = "ACCEPT_CONSENT",
  SIGN_IN_FROM_HOME_BANNER = "SIGN_IN_FROM_HOME_BANNER",
  SIGN_IN_FROM_SIDE_MENU = "SIGN_IN_FROM_SIDE_MENU",
  SIGN_OUT = "SIGN_OUT",
  ENTERED_NAME = "ENTERED_NAME",
  ENTERED_DOB = "ENTERED_DOB",
  ENTERED_GENDER = "ENTERED_GENDER",
  VIEW_MENU = "VIEW_MENU",
  DINE_IN_SELECTION = "DINE_IN_SELECTION",
  CAR_PICK_UP_SELECTION = "CAR_PICK_UP_SELECTION",
  PICKUP_SELECTION = "PICKUP_SELECTION",
  DELIVERY_SELECTION = "DELIVERY_SELECTION",
  ORDER_TYPE_SELECTION = "ORDER_TYPE_SELECTION",
  BRANCH_SELECTION = "BRANCH_SELECTION",
  BRANCH_AND_ORDER_TYPE_FROM_BURGER_MENU = "BRANCH_AND_ORDER_TYPE_FROM_BURGER_MENU",
  BRANCH_AND_ORDER_TYPE_FROM_ITEM_SELECTION = "BRANCH_AND_ORDER_TYPE_FROM_ITEM_SELECTION",
  BRANCH_AND_ORDER_TYPE_SELECTION_FROM_BANNERS = "BRANCH_AND_ORDER_TYPE_SELECTION_FROM_BANNERS",
  REWARDS_PAGE_FROM_REWARDS_TAB = "REWARDS_PAGE_FROM_REWARDS_TAB",
  REWARDS_PAGE_FROM_SEE_DETAILS_ABOVE_MILESTONE_METER = "REWARDS_PAGE_FROM_SEE_DETAILS_ABOVE_MILESTONE_METER",
  REWARDS_PAGE_SCROLL_DEPTH = "REWARDS_PAGE_SCROLL_DEPTH",
  REWARDS_POP_UP_SCROLL_DEPTH = "REWARDS_POP_UP_SCROLL_DEPTH",
  CATEGORY_BUTTON = "CATEGORY_BUTTON",
  ENTERED_PHONE_NUMBER = "ENTERED_PHONE_NUMBER",
  ENTERED_OTP = "ENTERED_OTP",
  VIEW_CART_PAGE = "VIEW_CART_PAGE",
  VIEW_ITEM_DETAILS = "VIEW_ITEM_DETAILS",
  ADD_TO_CART = "ADD_TO_CART",
  REMOVE_FROM_CART = "REMOVE_FROM_CART",
  CHANGE_COUNTER = "CHANGE_COUNTER",
  VIEW_CHECKOUT_PAGE = "VIEW_CHECKOUT_PAGE",
  ADDS_TIP = "ADDS_TIP",
  REMOVED_TIP = "REMOVED_TIP",
  PAYMENT_CONFIRMATION_PAGE = "PAYMENT_CONFIRMATION_PAGE",
  ORDER_SUMMARY_PAGE = "ORDER_SUMMARY_PAGE",
  PAYMENT_FAILED_PAGE = "PAYMENT_FAILED_PAGE",
  CHANGE_LANGUAGE = "CHANGE_LANGUAGE",
  LAND_WITH_ENROLLMENT = "LAND_WITH_ENROLLMENT",
  ENTERED_NAME_ENROLLMENT = "ENTERED_NAME_ENROLLMENT",
  ENTERED_DELIVERY_INFO = "ENTERED_DELIVERY_INFO",
  OUT_OF_DELIVERY_ZONE = "OUT_OF_DELIVERY_ZONE",
  ENTERED_WEBSITE_USING_QRLINK = "ENTERED_WEBSITE_USING_QRLINK",
  VIEW_PREVIOUS_ORDERS = "VIEW_PREVIOUS_ORDERS",
  PAGE_404 = "PAGE_404",
  DEBUGGING = "DEBUGGING",
  PARTNER_LOGO_DISCONNECT = "PARTNER_LOGO_DISCONNECT",
  PARTNER_ACCOUNT_DISCONNECT = "PARTNER_ACCOUNT_DISCONNECT",
  DETECT_CLOSEST_BRANCH = "DETECT_CLOSEST_BRANCH",
  CHANGE_BRANCH_FROM_CART = "CHANGE_BRANCH_FROM_CART",
  CHANGE_BRANCH_FROM_CHECKOUT = "CHANGE_BRANCH_FROM_CHECKOUT",
  CHANGE_ORDER_TYPE_FROM_CART = "CHANGE_ORDER_TYPE_FROM_CART",
  CONFIRM_BRANCH_AND_ORDER_TYPE = "CONFIRM_BRANCH_AND_ORDER_TYPE",
  ORDER_BLOCKED = "ORDER_BLOCKED",
  LIVE_TRACKING_TRIGGERED = "LIVE_TRACKING_TRIGGERED",
  LIVE_TRACKING_OPENED = "LIVE_TRACKING_OPENED",
  LIVE_TRACKING_DRIVER_CALLED = "LIVE_TRACKING_DRIVER_CALLED",
  MAP_SEARCH = "MAP_SEARCH",
  MAP_SEARCH_DROPDOWN_CLICK = "MAP_SEARCH_DROPDOWN_CLICK",
  CONFIRM_ADDRESS = "CONFIRM_ADDRESS",
  WELCOME_DRAWER_OPENED = "WELCOME_DRAWER_OPENED",
  WELCOME_DRAWER_SKIPPED = "WELCOME_DRAWER_SKIPPED",
  ENTERED_WEBSITE = "ENTERED_WEBSITE",
  DOWNLOAD_APP_POPUP_DOWNLOAD_CLICK = "DOWNLOAD_APP_POPUP_DOWNLOAD_CLICK",
  DOWNLOAD_APP_POPUP_DISMISS = "DOWNLOAD_APP_POPUP_DISMISS",
  OFFLINE_REWARD_OPENED = "OFFLINE_REWARD_OPENED",
  SWITCHED_TO_ONLINE = "SWITCHED_TO_ONLINE",
  OFFLINE_XP_OPENED = "OFFLINE_XP_OPENED",
  ELIGIBLE_BRANCHES_VIEWED_OFFLINE = "ELIGIBLE_BRANCHES_VIEWED_OFFLINE",
  ELIGIBLE_BRANCHES_BACK_CLICKED_OFFLINE = "ELIGIBLE_BRANCHES_BACK_CLICKED_OFFLINE",
  LOYALTY_CARD_QR_VIEWED = "LOYALTY_CARD_QR_VIEWED",
  ADD_A_NOTE_IN_ITEM_DETAILS = "ADD_A_NOTE_IN_ITEM_DETAILS",
  ADD_ADDON_IN_ITEM_DETAILS = "ADD_ADDON_IN_ITEM_DETAILS",
  ADD_ALL_FROM_PREVIOUS_ORDERS = "ADD_ALL_FROM_PREVIOUS_ORDERS",
  ADD_ITEM_FROM_EMPTY_CART = "ADD_ITEM_FROM_EMPTY_CART",
  ADD_ITEM_FROM_MENU = "ADD_ITEM_FROM_MENU",
  ADD_OTHER_ITEMS_FROM_CART = "ADD_OTHER_ITEMS_FROM_CART",
  APPLY_FLASH_OFFER_FROM_BANNER = "APPLY_FLASH_OFFER_FROM_BANNER",
  APPLY_FLASH_OFFER_FROM_REWARDS_PAGE = "APPLY_FLASH_OFFER_FROM_REWARDS_PAGE",
  APPLY_FLASH_OFFER_FROM_CART = "APPLY_FLASH_OFFER_FROM_CART",
  APPLY_REWARD_FROM_CART = "APPLY_REWARD_FROM_CART",
  APPLY_REWARD_FROM_REWRADS_PAGE = "APPLY_REWARD_FROM_REWRADS_PAGE",
  APPLY_FLASH_OFFER_FROM_REWARDS_POP_UP = "APPLY_FLASH_OFFER_FROM_REWARDS_POP_UP",
  APPLY_REWARD_FROM_REWRADS_POP_UP = "APPLY_REWARD_FROM_REWRADS_POP_UP",
  CART_ABANDONMENT = "CART_ABANDONMENT",
  CHECKOUT_ABANDONMENT = "CHECKOUT_ABANDONMENT",
  CALL_BRANCH = "CALL_BRANCH",
  GO_TO_BRANCH = "GO_TO_BRANCH",
  DEAD_CLICKS_ON_MILESTONE_METER = "DEAD_CLICKS_ON_MILESTONE_METER",
  GO_TO_MENU_FROM_ACTIVE_ORDER = "GO_TO_MENU_FROM_ACTIVE_ORDER",
  IN_STORE_PAYMENT_SELECTED = "IN_STORE_PAYMENT_SELECTED",
  ONLINE_PAYMENT_SELECTED = "ONLINE_PAYMENT_SELECTED",
  KEEP_OFFER = "KEEP_OFFER",
  REMOVE_OFFER = "REMOVE_OFFER",
  LOCKED_REWARDS_CLICK = "LOCKED_REWARDS_CLICK",
  MENU_GRID_VIEW = "MENU_GRID_VIEW",
  MENU_LIST_VIEW = "MENU_LIST_VIEW",
  RATE_FROM_PREVIOUS_ORDERS = "RATE_FROM_PREVIOUS_ORDERS",
  VIEW_ACTIVE_ORDER = "VIEW_ACTIVE_ORDER",
  VIEW_ALL_REWARDS_FROM_REWARDS_PAGE = "VIEW_ALL_REWARDS_FROM_REWARDS_PAGE",
  VIEW_PREVIOUS_ORDERS_FROM_MY_ORDERS_TAB = "VIEW_PREVIOUS_ORDERS_FROM_MY_ORDERS_TAB",
  VIEW_REWARDS = "VIEW_REWARDS",
  SCHEDULED_ORDER_SELECTED = "SCHEDULED_ORDER_SELECTED",
  PAY_IN_CHECKOUT = "PAY_IN_CHECKOUT",
  VIEW_PREVIOUS_ORDERS_FROM_BURGER_MENU = "VIEW_PREVIOUS_ORDERS_FROM_BURGER_MENU",
  REWARDS_PAGE_FROM_BURGER_MENU = "REWARDS_PAGE_FROM_BURGER_MENU",
  ADD_ITEM_ATTEMPT_BEFORE_BRANCH_AND_ORDER_TYPE_SELECTION = "ADD_ITEM_ATTEMPT_BEFORE_BRANCH_AND_ORDER_TYPE_SELECTION",

  // hasWelcomeDrawerV3 events
  CAR_PICK_UP_BUTTON = "CAR_PICK_UP_BUTTON",
  BEACH_DELIVERY_BUTTON = "BEACH_DELIVERY_BUTTON",
  CABIN_DELIVERY_BUTTON = "CABIN_DELIVERY_BUTTON",
  SWITCH_TO_ARABIC_FROM_WELCOME = "SWITCH_TO_ARABIC_FROM_WELCOME",
  SWITCH_TO_ENGLISH_FROM_WELCOME = "SWITCH_TO_ENGLISH_FROM_WELCOME",
  CHANGE_ORDER_TYPE_FROM_MENU = "CHANGE_ORDER_TYPE_FROM_MENU",
  CLICKED_LOGIN_FROM_ADDRESSES = "CLICKED_LOGIN_FROM_ADDRESSES",
  USED_SEARCH_ON_MAP = "USED_SEARCH_ON_MAP",
  DETECT_LOCATION_ON_MAP = "DETECT_LOCATION_ON_MAP",
  SKIPPED_ADDRESS_FORM = "SKIPPED_ADDRESS_FORM",
  CLICKED_WELCOME_BANNER_ON_MENU = "CLICKED_WELCOME_BANNER_ON_MENU",
  CLICKED_WELCOME_BANNER_IN_CART = "CLICKED_WELCOME_BANNER_IN_CART",
  SEARCHED_FOR_BRANCH = "SEARCHED_FOR_BRANCH",

  CLICKED_PAY_POINTS_IN_MENU = "CLICKED_PAY_POINTS_IN_MENU",
  CLICKED_PAY_POINTS_IN_CART = "CLICKED_PAY_POINTS_IN_CART",
  CLICKED_PAY_POINTS_IN_REWARDS_POPUP = "CLICKED_PAY_POINTS_IN_REWARDS_POPUP",
  USED_PAY_WITH_POINTS_SLIDER = "USED_PAY_WITH_POINTS_SLIDER",
  USED_PAY_WITH_POINTS_QUICK_BUTTONS = "USED_PAY_WITH_POINTS_QUICK_BUTTONS",
  USED_PAY_WITH_POINTS_CUSTOM_FIELD = "USED_PAY_WITH_POINTS_CUSTOM_FIELD",
  CLICKED_PAY_WITH_POINTS_HIDE_CUSTOM_FIELD = "CLICKED_PAY_WITH_POINTS_HIDE_CUSTOM_FIELD",
  CLICKED_OTHER_TIERS = "CLICKED_OTHER_TIERS",
  CLICKED_TIER_POPUP_CTA = "CLICKED_TIER_POPUP_CTA",

  // dineInTableNumber events
  DINE_IN_TABLE_NUMBER_ENTERED = "DINE_IN_TABLE_NUMBER_ENTERED",
  DINE_IN_TABLE_NUMBER_VALIDATION_EMPTY = "DINE_IN_TABLE_NUMBER_VALIDATION_EMPTY",

  // Guest wallet events (prepits/project#4263); accepted by the backend from
  // prepits/prepareit-backend#707.
  WALLET_BALANCE_CONTAINER_CLICKED = "WALLET_BALANCE_CONTAINER_CLICKED",
  WALLET_TOP_UP_CTA_CLICKED = "WALLET_TOP_UP_CTA_CLICKED",
  WALLET_PRESET_SELECTED = "WALLET_PRESET_SELECTED",
  WALLET_CUSTOM_AMOUNT_ENTERED = "WALLET_CUSTOM_AMOUNT_ENTERED",
  WALLET_USED_AT_CHECKOUT_TOGGLED = "WALLET_USED_AT_CHECKOUT_TOGGLED",
}

export enum MAIN_OFFER_TYPE {
  FIXED_AMOUNT = "FIXED_AMOUNT",
  PERCENTAGE_AMOUNT = "PERCENTAGE_AMOUNT",
  FREE_ITEM = "FREE_ITEM",
  DISCOUNT_ITEM = "DISCOUNT_ITEM",
  MULTIPLIER = "MULTIPLIER",
  BOGO = "BOGO",
  BUNDLE = "BUNDLE",
}

export enum COOKIE_ENUM {
  TOKEN = "token",
  VISITOR = "visitor",
  TERMSANDCONDITIONS = "isTermsAndConditions",
  OFFER_MODAL = "offerModalCookie",
  VERIFY_EMAIL_POPUP_LAST_APPEARED = "verifyEmailPopupLastAppeared",
  LAST_SELECTED_FRANCHISE = "lastSelectedFranchise",
  // Session flag: the customer explicitly skipped the welcome/order-type flow,
  // so the welcome drawer must not auto-reopen on the next home mount.
  WELCOME_DRAWER_SKIPPED = "welcomeDrawerSkipped",
  DOWNLOAD_APP_POPUP_LAST_SHOWN = "downloadAppPopupLastShown",
  // Business-day key of the last session we reported to the backend, so the
  // marketing identifiers are sent about once a day rather than every page load.
  META_SESSION_LAST_SENT = "metaSessionLastSent",
}

export enum URL_PARAMS {
  TABLE = "table",
  FRANCHISE = "franchise",
  ORDER_TYPE = "order_type",
  REFRESH = "refresh",
  OUTDATED_ITEMS = "outdated_items",
  OFFER = "offer",
  PAY = "pay",
  INVALID_FRANCHISE = "invalid_franchise",
  OUT_OF_ZONE = "out_of_zone",
  PHONE = "phone",
  COUNTRY = "country",
  OFFERS_TAB = "offers",
  DELIVERY_TYPE = "deliveryType",
  QRCODE = "qrcode",
  SHOW_DELIVERY_TOGGLE = "show_delivery_toggle",
  NEXT_PAGE = "next_page",
  // The order type to restore when backing out of the location screen — the URL
  // carries order_type=deliveryv2 for the address flow, so we stamp the prior
  // one here to return the customer to it on cancel.
  PREV_ORDER_TYPE = "prev_order_type",
  // For a deliveryV2 order type (car pickup, cabin, ...) the coarse
  // prev_order_type is just "deliveryv2"; this carries the specific delivery
  // type id so the exact config can be restored on cancel.
  PREV_DELIVERY_TYPE_ID = "prev_delivery_type_id",
  PARNTER_LOGIN = "partnerlogin",
  LOGIN = "login",
  RECEIPT_ID = "receipt_id",
  PROMO = "promo",
  EXCLUDED = "excluded",
  ERROR = "error",
  PAY_TYPE = "payType",
  ITEMS_OUT_OF_STOCK = "items_out_of_stock",
  CONFIRM = "confirm",
  BLOCKED = "blocked",
  EMPTY_CART = "empty_cart",
  SOURCE = "source",
  OFFLINE_MODE = "offline_mode",
}

export enum offerSectionComponentTypeEnum {
  V2 = "v2",
}

export enum DISPLAYED_NAME {
  NAME = "name",
  DESCRIPTION = "description",
  CATEGORY_NAME = "category_name",
  ITEM_NAME = "item_name",
  FULL_NAME = "fullName",
  TITLE = "TITLE",
}

export enum ROUNDING_ENUM {
  UP = "up",
  DOWN = "down",
  AVERAGE = "average",
  NONE = "none",
}

export enum COUNTER_CLICK_TYPE {
  ADD = "ADD",
  SUBTRACT = "SUBTRACT",
}

export enum REQUEST_ERROR {
  EMAIL_ALREADY_IN_USE = "AuthService_GenerateOrganizationCustomerToken_MailAlreadyInUseWithDifferentCustomer",
  INVALID_MAIL = "AuthService_GenerateOrganizationCustomerToken_InvalidMail",
  NOT_ORGANIZATION_EMPLOYEE = "AuthService_GenerateOrganizationCustomerToken_NotOrganizationEmployee",
}

export enum FeedBackTagsEnum {
  SERVICE = "SERVICE",
  APP = "APP",
  QUALITY = "QUALITY",
  ORDER = "ORDER",
  WAITER_BEHAVIOUR = "WAITER",
}

export enum PromoCodeInvalidReason {
  INVALID = "INVALID",
  EXPIRED = "EXPIRED",
  COUNT_OF_USAGE_PER_CUSTOMER = "COUNT_OF_USAGE_PER_CUSTOMER",
  COUNT_OF_USAGE = "COUNT_OF_USAGE",
  REFERRAL_CODE_WITH_NOT_FIRST_TIME_ORDER = "REFERRAL_CODE_WITH_NOT_FIRST_TIME_ORDER",

  PROMO_CODE_NOT_FOUND = "PROMO_CODE_NOT_FOUND",
  CHAIN_NOT_FOUND = "CHAIN_NOT_FOUND",
  BRANCH_NOT_FOUND = "BRANCH_NOT_FOUND",
  CUSTOMER_NOT_FOUND_FOR_ACCOUNT = "CUSTOMER_NOT_FOUND_FOR_ACCOUNT",
  NO_ACTIVE_PROMO_VERSION = "NO_ACTIVE_PROMO_VERSION",
  PROMO_NOT_VALID_FOR_USAGE_PERIOD = "PROMO_NOT_VALID_FOR_USAGE_PERIOD",
  MISSING_OFFER_ASSIGNMENTS = "MISSING_OFFER_ASSIGNMENTS",
  NO_ELIGIBLE_OFFER_FOR_CONTEXT = "NO_ELIGIBLE_OFFER_FOR_CONTEXT",
  INVALID_PERIOD_BOUNDS = "INVALID_PERIOD_BOUNDS",
  PROMO_PERIOD_USAGE_LIMIT_EXCEEDED = "PROMO_PERIOD_USAGE_LIMIT_EXCEEDED",
  PROMO_LIFETIME_USAGE_LIMIT_EXCEEDED = "PROMO_LIFETIME_USAGE_LIMIT_EXCEEDED",
}

export enum DeliveryOptions {
  NOW = "NOW",
  FOR_IFTAR = "FOR_IFTAR",
  SCHEDULED = "SCHEDULED",
}

export enum ScheduleDays {
  TODAY = "TODAY",
  TOMORROW = "TOMORROW",
  AFTER_TOMORROW = "AFTER_TOMORROW",
}

/**
 * What a tag means, as served by the menu API (`tag.type`).
 *
 * LABEL is a free-form chip on the menu card and the item page; ALLERGENS is
 * the allergen list on the item page. Anything unrecognised is ignored rather
 * than rendered as a chip, so a new kind added server-side cannot leak into the
 * menu before the guest knows how to draw it.
 */
export enum TAG_TYPE {
  LABEL = "LABEL",
  ALLERGENS = "ALLERGENS",
}

export enum I18LanguagesEnum {
  AR = "ar",
  SA = "ar-SA",
  EN = "en",
  FR = "fr",
}

export enum SOCKET_NAMESPACE {
  WAITER = "/socket/waiter",
  RESTAURANT = "/socket/restaurant",
  FRANCHISE = "/socket/franchise",
}

export enum RESTAURANT_SOCKET_EVENT {
  RESTAURANT_ITEM_STATUS_CHANGE = "RESTAURANT_ITEM_STATUS_CHANGE",
  MENU_VERSION_CHANGE = "MENU_VERSION_CHANGE",
  RECEIPT_STATE_CHANGE = "RECEIPT_STATE_CHANGE",
  ORGANICATION_CUSTOMER_VERIFIED = "ORGANICATION_CUSTOMER_VERIFIED",
  REWARD_REDEEMED = "REWARD_REDEEMED",
  WALLET_CARD_ADDED = "WALLET_CARD_ADDED",
}

export enum FRANCHISE_SOCKET_EVENT {
  UPDATE_SCHEDULING_CUTOFFS = "UPDATE_SCHEDULING_CUTOFFS",
}

export enum MENU_STYLE {
  ITEM = "item",
  LIST = "list",
}

export enum RESTAURANT_IMAGE_TYPE {
  TOP_BANNER = "TOP_BANNER",
  BOTTOM_BANNER = "BOTTOM_BANNER",
  FAVICON = "FAVICON",
  OPEN_GRAPH = "OPEN_GRAPH",
}

export enum FranchiseFeaturesEnum {
  DELIVERY = "DELIVERY",
  TAKE_OUT = "TAKE_OUT",
  DINE_IN = "DINE_IN",
  OFFERS_POP_UP = "OFFERS_POP_UP",
  LOCATION_DROPDOWN = "LOCATION_DROPDOWN",
  ADMIN_HOME_PAGE = "ADMIN_HOME_PAGE",
  MENU_REPORT_DATA = "MENU_REPORT_DATA",
  DELETED_MENU_REPORT_DATA_ENUM = "DELETED_MENU_REPORT_DATA_ENUM",
  PRINTER_DATA = "PRINTER_DATA",
  LOYALTY_PER_RESTAURANT = "LOYALTY_PER_RESTAURANT",
  CUSTOM_PRICING_MENU_MANAGEMENT = "CUSTOM_PRICING_MENU_MANAGEMENT",
  HAS_FEEDBACK = "HAS_FEEDBACK",
  IS_OPEN_V2 = "IS_OPEN_V2",
  HAS_TABLES = "HAS_TABLES",
  IS_ONLINE_STORE = "IS_ONLINE_STORE",
  HAS_SCHEDULED_ORDER = "HAS_SCHEDULED_ORDER",
  FILTER_WAITER_TABS = "FILTER_WAITER_TABS",
  HAS_DELIVERY_ZONE_NAME = "HAS_DELIVERY_ZONE_NAME",
  QRCODE_AUTO_SELECT = "QRCODE_AUTO_SELECT",
  ABOVE_THE_LINE_DISABLES_ALL_OTHER_OFFERS = "ABOVE_THE_LINE_DISABLES_ALL_OTHER_OFFERS",
  HAS_SKIP_BTN = "HAS_SKIP_BTN",
  SELF_SERVICE_WITHOUT_SIGN_IN = "SELF_SERVICE_WITHOUT_SIGN_IN",
  LOYALTY_REVAMP = "LOYALTY_REVAMP",
  FOR_FEATURE_SHOWCASE = "FOR_FEATURE_SHOWCASE",
}

export enum ContainerStyle {
  FLUID = "FLUID",
  BOXED = "BOXED",
}

export enum PayTypeEnum {
  PAY_IN_STORE = "pay-in-store",
  PAY_POS = "pay-pos",
  PAY_SUCCESS = "pay-success",
  PAY_FAILED = "pay-failed",
  PAY_PENDING = "pay-pending",
}

export enum PaymobPosReceiptStateEnum {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAIL = "FAIL",
}

export enum OfferCardSize {
  small,
  medium,
  large,
}

export enum ListSurface {
  home = "home",
  page = "page",
}

export enum DeliveryTypeDisplayName {
  TABLE_DELIVERY = "table-delivery",
  BEACH_DELIVERY = "beach-delivery",
  CAR_PICKUP = "car-pick-up",
  OFFICE_DELIVERY = "office-delivery",
  CABIN_DELIVERY = "cabin-delivery",
}
